import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const BORDER = '#E5E7EB';
const TEXT_MUTED = '#8A93A6';
const TEXT_STRONG = '#1F2A3A';

const IconSearch = ({ size = 15, color = TEXT_MUTED }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="11" cy="11" r="7" />
    <path d="M21 21l-4.5-4.5" />
  </svg>
);

IconSearch.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    px: 1.5,
    py: '9px',
    border: `1px solid ${BORDER}`,
    borderRadius: '8px',
    bgcolor: '#fff',
  },
  input: {
    border: 'none',
    outline: 'none',
    fontSize: 13,
    flex: 1,
    color: TEXT_STRONG,
    background: 'transparent',
    width: '100%',
    fontFamily: 'inherit',
  },
};

export default function SearchInput({ value, onChange, placeholder, onKeyDown, autoFocus, sx }) {
  return (
    <Box sx={{ ...styles.container, ...sx }}>
      <IconSearch />
      <input
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        style={styles.input}
        autoFocus={autoFocus}
      />
    </Box>
  );
}

SearchInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  onKeyDown: PropTypes.func,
  autoFocus: PropTypes.bool,
  sx: PropTypes.object,
};

SearchInput.defaultProps = {
  placeholder: '',
  onKeyDown: undefined,
  autoFocus: false,
  sx: {},
};
